<header>
    <app-header headerName="Forgot Password"></app-header>
  </header>
<section>
    <div class="outer-conatiner">
       <div class="inner-container">
        <app-page-title pageTitle='Village of Volo Overnight Parking'></app-page-title>
          <form  [formGroup]="resetPasswordForm" (ngSubmit)="onSubmitReset()">
           <div>
            <i class="fa fa-unlock-alt" aria-hidden="true"></i> 
            <h1 color="vov-ui-primary">Reset Password</h1>
           </div>
          <div class="container-wrapper">
             <mat-form-field appearance="fill">
                <mat-label>New Password</mat-label>
                <input  #passwordField formControlName="password" placeholder="" type="password"  matInput/>
                <span  toggle="#password-field"
                    class="fa password-visible field-icon toggle-password"
                    [title]="showPassword ? 'hide password' : 'show password'"
                    [ngClass]="{'fa-eye': showPassword, 'fa-eye-slash': !showPassword}"
                    (click)="togglePassword()"></span>
                <mat-error *ngIf="resetPasswordForm.get('password').hasError('required')">
                  Password is required.
                </mat-error> 
                <mat-error *ngIf="!resetPasswordForm.get('password').hasError('required') || resetPasswordForm.get('password').hasError('minLength')">
                  Password must be at least 6 characters.
                </mat-error> 
             </mat-form-field>
             <mat-form-field appearance="fill">
              <mat-label>Confirm New Password</mat-label>
              <input #ConfirmpasswordField formControlName="confirmPassword" [errorStateMatcher]="matcher"  placeholder="" type="password"  matInput />
              <span toggle="#ConfirmpasswordField"
                class="fa password-visible field-icon toggle-password"
                [title]="ConfirmshowPassword ? 'hide password' : 'show password'"
                [ngClass]="{'fa-eye': showPassword, 'fa-eye-slash': !showPassword}"
                (click)="toggleConfirmPassword()"></span> 
              <!-- <mat-error *ngIf="resetPasswordForm.get('confirmPassword').hasError('required')">
                Confirm Password is required
              </mat-error>  -->
              <mat-error *ngIf="resetPasswordForm.hasError('notSame')">
                Passwords do not match
              </mat-error>  
           </mat-form-field>
             <button mat-button class="button-primary" type="submit" [disabled]='resetPasswordForm.invalid' color="vov-ui-primary">Set Password</button>
             <!-- <a style="padding: 22px;  display: flex;justify-content: center;color: #6A0721;font-weight: bold;text-decoration: none;"color="vov-ui-primary" >Back</a> -->
          </div>
        </form>
       </div>
    </div>
  </section>
  <footer></footer>